// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-logo-link_a6d93e1c{text-decoration:none}.page-logo-link_a6d93e1c:hover{text-decoration:none}", ""]);
// Exports
export var pageLogoLink = "page-logo-link_a6d93e1c";
export default ___CSS_LOADER_EXPORT___;
